import {
    getCardDevice,
    persistCardDevice,
} from '../../../constants/state';
import { SAVE_CARD_DEVICE, TOGGLE_CARD_DEVICE_SELECT } from './cardDevice-actions';


const cardDeviceReducer = (state = { data: getCardDevice(), openSelect: false }, action) => {
    let newState;
    switch (action.type) {
    case TOGGLE_CARD_DEVICE_SELECT:
        newState = {
            ...state,
            openSelect: action.open,
        };
        break;
    case SAVE_CARD_DEVICE:
        newState = {
            ...state,
            data: action.cardDevice,
        };
        persistCardDevice(action.cardDevice);
        break;
    default:
        newState = state;
    }
    return newState;
};

export default cardDeviceReducer;
